import { toast } from "react-toastify";

import {
  GetBillingPortalRequestBodyType,
  GetBillingPortalResponseBodyType,
} from "@intelligems/ig-types";
import { ApiRequest } from "@src/api/types/api";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const getBillingPortal = async (
  data: ApiRequest<GetBillingPortalRequestBodyType>
) => {
  const resp = await api.post<GetBillingPortalResponseBodyType>(
    `/v2/billing-portal`,
    data.body
  );
  return resp.data;
};

export const useGetBillingPortal = (copyToClipboard: boolean) => {
  return useMutation<
    GetBillingPortalResponseBodyType,
    Error,
    ApiRequest<GetBillingPortalRequestBodyType>
  >({
    mutationFn: async (data: ApiRequest<GetBillingPortalRequestBodyType>) =>
      getBillingPortal(data),
    onSuccess: async (data) => {
      if (copyToClipboard) {
        await navigator.clipboard.writeText(data.url);
        toast.success("Billing portal link copied to clipboard");
      } else {
        window.open(data.url, "_blank");
      }
    },
  });
};
